<script lang="ts">
  import { Button } from "$lib/components/ui/button/index.ts";
  import { Label } from "$lib/components/ui/label/index.ts";
  import { Input } from "$lib/components/ui/input/index.ts";
  import * as Card from "$lib/components/ui/card/index.ts";
  import { loginWithPassword } from "../services/auth-service";

  let email = "";
  let password = "";
  let isSubmitting = false;
  let errorMessage = "";

  const handleSubmit = async (event: SubmitEvent) => {
    event.preventDefault();
    errorMessage = "";
    isSubmitting = true;

    try {
      const result = await loginWithPassword(email, password);
      if (!result.ok) {
        errorMessage = 'Login failed';
      }
    } finally {
      isSubmitting = false;
    }
  };

</script>

<main class="flex min-h-screen items-center justify-center bg-background px-4 py-12">
  <Card.Root class="w-full max-w-sm">
    <Card.Header class="text-center">
      <Card.Title>Login to Attityde Tools</Card.Title>
      <Card.Description>
        Tools for making Attityde great again
      </Card.Description>
      <Card.Action>
      </Card.Action>
    </Card.Header>
    <form on:submit={handleSubmit}>
      <Card.Content>
        <div class="flex flex-col gap-2">
          <div class="grid gap-2">
            <Input id="email" placeholder="Email" type="email" bind:value={email} required />
          </div>
          <div class="grid">
            <div class="flex items-center">
            </div>
            <Input id="password" placeholder="Password" type="password" bind:value={password} required />
          </div>
        </div>
        {#if errorMessage}
          <p class="mt-4 text-sm text-destructive">{errorMessage}</p>
        {/if}
      </Card.Content>
      <Card.Footer class="flex-col gap-2 pt-6">
        <Button type="submit" class="w-full" disabled={isSubmitting}>
          {isSubmitting ? "Logging in..." : "Login"}
        </Button>
      </Card.Footer>
    </form>
  </Card.Root>
</main>
